import type { FeatureFlags } from '@noths/polaris-client-feature-flags';
import type { CurrencyCode, DeliveryZoneCode } from '@noths/polaris-client-localisation';
import { createSlice } from '@reduxjs/toolkit';

export type CookieConsent = {
  analyticalExperienceCookiesConsented?: boolean;
  functionalCookiesConsented?: boolean;
  performanceCookiesConsented?: boolean;
  targetingAdvertisingCookiesConsented?: boolean;
  technicalCookiesConsented?: boolean;
};

export interface UserState {
  bot: boolean;
  contentPreview?: boolean;
  cookieConsent?: CookieConsent;
  countryCode: string;
  currencyCode: CurrencyCode;
  deliveryZone?: DeliveryZoneCode;
  featureFlags?: FeatureFlags;
  gaVisitorId?: string;
}

export const initialState: Readonly<UserState> = {
  bot: false,
  countryCode: 'GB',
  currencyCode: 'GBP',
};

export const { actions, name, reducer } = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setContentPreview: (state, { payload }) => {
      state.contentPreview = payload === true;
    },
    setCookieConsent: (state, { payload }) => {
      if (payload) {
        state.cookieConsent = payload;
      }
    },
    setDeliveryZone: (state, { payload }) => {
      if (payload) {
        state.deliveryZone = payload;
      }
    },
    setFeatureFlags: (state, { payload }) => {
      if (payload) {
        state.featureFlags = payload;
      }
    },
  },
});
